export const getSelectArrayItem = (array, label) =>
  array.find((item) => item.label === label)
